import { getRequestTransportErrorMessage } from '#/utils/requestError';

export function getPaymentRequestApiErrorMessage(
  error,
  fallback = '操作失敗，請稍後再試',
) {
  const transportMessage = getRequestTransportErrorMessage(error);
  if (transportMessage) {
    return transportMessage;
  }

  const data = error?.response?.data;
  if (data?.code === 'RESOURCE_VERSION_CONFLICT') {
    return data?.message || '資料已被他人修改，請重新載入後再試';
  }
  if (data?.code === 'UPDATED_AT_REQUIRED') {
    return data?.message || '缺少更新時間，請重新載入後再試';
  }
  if (data?.code === 'PAYMENT_REQUEST_AMOUNT_MISMATCH') {
    return data?.message || '請款總額與引用憑證合計不符';
  }

  return data?.message || fallback;
}

export function isPaymentRequestVersionConflict(error) {
  return error?.response?.data?.code === 'RESOURCE_VERSION_CONFLICT'
    || error?.response?.status === 409;
}
